// TODO: cleanup : Move to account component by splitting into multiple reducers if possible
import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import get from 'lodash/get';
import {
    getRewards,
    getPoints,
    updateRewardsSettings,
    putRewardsProfile,
} from 'yoda-interfaces/lib/Rewards/RewardsApi';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { navigateToRewardsHome } from 'yoda-account-components/lib/common/Constants';
import { DP_USER_NAME, DP_USER_STATE, DP_SAVED_ITEMS_COUNT, ACCOUNT_ID } from '../common/Constants';
import * as AccountActionTypes from '../actionTypes/AccountActionTypes';
import FactorySaga from './FactorySaga';
import * as RewardsActionTypes from '../actionTypes/RewardsActionTypes';

export function* rewardsSaga(action) {
    let rewardsDetails;
    const userProfileInfo = {};
    try {
        const response = yield call(FactorySaga, getRewards, action, undefined, false);
        const isLoading = false;
        if (response.isSuccess) {
            rewardsDetails = {
                data: get(response, 'response.data', {}),
                isLoading,
            };

            const context = (state) => state.context;
            const appContext = yield select(context);
            const {
                points = {},
                certificates = {},
                balance = {},
                recentActivity = {},
                tier = {},
            } = get(rewardsDetails, 'data', {});
            TokenProvider.set('DP_REWARDS_DETAILS', {
                points,
                certificates,
                balance,
                recentActivity,
                tier,
            });

            // store tier
            const tierCode = get(rewardsDetails, 'data.tier.code', '');
            const rewardsTier = tierCode.toUpperCase() === 'BASE' ? 'base' : tierCode.toLowerCase();
            TokenProvider.set('DP_REWARDS_TIER', rewardsTier);

            // store status
            const rewardsStatus = get(rewardsDetails, 'data.status');
            userProfileInfo.rewardsStatus = rewardsStatus;
            TokenProvider.set('DP_REWARDS_STATUS', rewardsStatus);

            // store certs
            const totalCertsValue = get(rewardsDetails, 'data.certificates.totalCertsValue', 0);
            const numberOfCerts = get(rewardsDetails, 'data.certificates.numberOfCerts', 0);
            const pointsAway = get(rewardsDetails, 'data.points.pointsAway', 0);
            userProfileInfo.totalCerts = totalCertsValue.toString();
            TokenProvider.set('DP_REWARDS_CERTS', userProfileInfo.totalCerts);
            TokenProvider.set('DP_REWARDS_CERTS_COUNT', numberOfCerts.toString());
            TokenProvider.set('DP_REWARDS_POINTS_AWAY', pointsAway.toString());

            // and store the rest of the world
            userProfileInfo.firstName = TokenProvider.get(DP_USER_NAME);
            userProfileInfo.accountId = TokenProvider.get(ACCOUNT_ID);
            userProfileInfo.userState = TokenProvider.get(DP_USER_STATE);
            userProfileInfo.savedItemsCount = TokenProvider.get(DP_SAVED_ITEMS_COUNT);

            yield all([
                put({ type: RewardsActionTypes.GET_REWARDS_REQUEST_SUCCESS, rewardsDetails }),
                put({ type: AccountActionTypes.GET_SITE_USER_PROFILE_SUCCESS, userProfileInfo }),
            ]);
        } else {
            rewardsDetails = {
                isLoading,
                error: get(response, 'response.data', { errorCode: '' }),
            };
            yield put({
                type: RewardsActionTypes.GET_REWARDS_REQUEST_ERROR,
                rewardsDetails,
            });
        }
    } catch (err) {
        if (action.payload.redirect) {
            getBrowserHistory().push(navigateToRewardsHome.mobile);
        } else {
            const error = {
                errorMessage: err.message,
                errorCode: 'EXCEPTION_IN_REWARDS_SAGA',
            };
            rewardsDetails = {
                isLoading: false,
                error,
            };
            yield put({
                type: RewardsActionTypes.GET_REWARDS_REQUEST_ERROR,
                rewardsDetails,
            });
        }
    }
}

export function* pointsSaga(action) {
    try {
        const pointDetails = get(yield call(FactorySaga, getPoints, action), 'response', {});
        yield put({ type: RewardsActionTypes.GET_POINT_REQUEST_SUCCESS, pointDetails });
    } catch (error) {
        yield put({
            type: RewardsActionTypes.GET_POINT_REQUEST_ERROR,
            error,
        });
    }
}

export function* updateRewardsSettingsSaga(action) {
    try {
        const { payload } = action;
        const rewardsSettingsDetails = get(
            yield call(FactorySaga, updateRewardsSettings, action),
            'response',
            {}
        );
        rewardsSettingsDetails.isLoading = false;
        if (rewardsSettingsDetails.status === 200) {
            rewardsSettingsDetails.isSuccess = true;
            for (let i = 0; i < payload.length; i += 1) {
                if (payload[i].path === '/contact') {
                    rewardsSettingsDetails.phoneNumber = payload[i].value.phone;
                } else if (payload[i].path === '/birthInfo') {
                    rewardsSettingsDetails.dateOfBirth = `${payload[i].value.month}/${payload[i].value.day}`;
                }
            }
            yield all([
                put({
                    type: RewardsActionTypes.UPDATE_REWARDS_SETTINGS_SUCCESS,
                    rewardsSettingsDetails,
                }),
                put({
                    type: RewardsActionTypes.REWARDS_PROFILE_UPDATE_SUCCESS,
                    rewardsSettingsDetails,
                }),
            ]);
        } else {
            const errorPayload = {
                error: {
                    errorMessage: 'Update rewards setting error',
                    errorCode: 'REWARDS_SETTINGS_DOB_ERROR',
                },
            };
            yield put({
                type: RewardsActionTypes.UPDATE_REWARDS_SETTINGS_ERROR,
                error: errorPayload,
            });
        }
    } catch (error) {
        yield put({
            type: RewardsActionTypes.UPDATE_REWARDS_SETTINGS_ERROR,
            error,
        });
    }
}

export function* linkCreditCard(action) {
    try {
        action.userAction = 'LINK_CARD';
        const linkDetails = get(yield call(FactorySaga, putRewardsProfile, action), 'response', {});
        linkDetails.cardNumber = action.payload.cardNumber;
        yield put({ type: RewardsActionTypes.LINK_CREDITCARD_SUCCESS, linkDetails });
    } catch (error) {
        yield put({
            type: RewardsActionTypes.LINK_CREDITCARD_ERROR,
            error,
        });
    }
}

function* watchRewardsSaga() {
    yield takeLatest(RewardsActionTypes.GET_REWARDS_REQUEST, rewardsSaga);
    yield takeLatest(RewardsActionTypes.GET_POINT_REQUEST, pointsSaga);
    yield takeLatest(RewardsActionTypes.LINK_CREDITCARD, linkCreditCard);
    yield takeLatest(RewardsActionTypes.UPDATE_REWARDS_SETTINGS, updateRewardsSettingsSaga);
    // yield takeLatest(RewardsActionTypes.POST_MISSING_POINTS, postMissingPointsSaga);
}

watchRewardsSaga.sagaName = 'rewardsSaga';
export default watchRewardsSaga;
